import { Component, Inject, Optional } from '@angular/core';
import { Project } from 'src/app/core/objects/project';
import { ProjectApiService } from 'src/app/core/services/project-api.service';
import { ProjectService } from 'src/app/core/services/project.service';
import { ModalOverlayRef } from '../../modal/modal-overlay-ref';
import { MODAL_DATA } from '../../modal/modal.service';
import { setLocalStorage } from '../../main-panel/utils/localStorageHelpers';

@Component({
    selector: 'gl-change-units',
    templateUrl: './change-units.component.html',
    styleUrls: ['./change-units.component.scss'],
    standalone: false
})
export class ChangeUnitsComponent {
  private project: Project;
  private currentWorkSpace: number;

  constructor(
    private modalRef: ModalOverlayRef,
    @Optional() @Inject(MODAL_DATA) public modalData: string,
    private projectService: ProjectService,
    private projectApiService: ProjectApiService,
  ) {
    this.modalRef.backgroundClicked();
    this.projectService.project.subscribe((project) => (this.project = project));
    this.projectService.currentWorkSpaceIndex.subscribe(
      (currentWorkSpace) => (this.currentWorkSpace = currentWorkSpace),
    );
  }

  public close() {
    this.modalRef.close();
  }

  public changeUnits() {
    const currentWorkSpaceId = this.project.workSpaces[this.currentWorkSpace]
      ? this.project.workSpaces[this.currentWorkSpace].id
      : undefined;
    if (this.modalData === 'mm') {
      setLocalStorage('mm', 'unit');
      this.projectApiService
        .projectOptionsUpdate({
          currentWorkSpaceId: currentWorkSpaceId,
          options: {
            unit: 'cm',
          },
        })
        .subscribe(() => {
          this.close();
          this.projectService.setCurrentWorkSpace(0);
        });
    } else if (this.modalData === 'cm' || this.modalData === 'lb') {
      setLocalStorage(this.modalData, 'unit');
      this.projectApiService
        .projectOptionsUpdate({
          currentWorkSpaceId: currentWorkSpaceId,
          options: {
            unit: this.modalData,
          },
        })
        .subscribe(() => {
          this.close();
          this.projectService.setCurrentWorkSpace(0);
        });
    }
  }
}
